<template>



            <div class="container" >


                    <nav class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <b-field label="Select Date" :type="{ 'is-danger': hasError }"
                                         :message="{ 'date is not available': hasError }">
                                    <b-datepicker v-model="date_selected"
                                                  placeholder="Click to select..."
                                                  icon="calendar-today"
                                                  range
                                    >
                                    </b-datepicker>
                                </b-field>
                            </div>
                            <div class="level-item">
                                <b-field label="#">
                                    <b-button type="is-primary is-light">Get Report</b-button>
                                </b-field>
                            </div>
                            <div class="level-item">
                                <b-field label="Clear">
                                    <b-button type="is-danger is-light">Clear</b-button>
                                </b-field>
                            </div>



                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <div class="level-item">
                                    <b-field label="Back">
                                        <b-button type="is-success" @click="closeModal">Back To Dashboard Report</b-button>
                                    </b-field>
                                </div>
                            </div>
                        </div>
                    </nav>

                    <hr>


                    <template>

                        <b-table
                                :data="isEmpty ? [] : dataDx"
                                bordered
                                striped
                                narrowed
                                hoverable
                                focusable
                                mobile-cards>

                            <b-table-column   label="ID"  v-slot="props">
                                {{ props.row.id }}
                            </b-table-column>

                            <b-table-column   label="Dx Code" v-slot="props">
                                {{ props.row.code }}
                            </b-table-column>

                            <b-table-column   label="Detail" v-slot="props">
                                {{ props.row.name }}
                            </b-table-column>

                            <b-table-column   label="Count" v-slot="props">
                                {{ props.row.cnt }}
                            </b-table-column>

                        </b-table>

                    </template>

            </div>


</template>

<script>
    import { getRandomFloat , getRandomInt } from '@/utils.js'
    export default {
        name: "Report002",
        methods:{
            closeModal(){
               this.$emit('close')
            },
            getRandomFloatSample(){
                return getRandomFloat()
            },
            getRandomIntSample(){
                return getRandomInt()
            }
        },
        computed:{

        },
        data(){
           return {
               date_selected : null,
               isEmpty: false,
               dataDx:[
                   {"id":"1","code":"A000113","name":"Lymphangioma","cnt": 20},
                   {"id":"2","code":"A000135","name":"Systemic histiocytosis","cnt": 22},
                   {"id":"3","code":"A000144","name":"Lymphoplasmacytic leukemia","cnt": 23},
                   {"id":"4","code":"A000323","name":"B-cell Lymphoblastic lymphoma/leukemia","cnt": 45},
                   {"id":"5","code":"A000333","name":"Angiocentric B-cell lymphoma (Lymphomatoid granulomatous)","cnt": 12},
                   {"id":"6","code":"A000555","name":"Hepatosplenic lymphoma","cnt": 3},
                   {"id":"7","code":"A000467","name":"Synovial  cell sarcoma","cnt": 43},
                   {"id":"8","code":"A000755","name":"Feline osteochondromatosis","cnt": 17},
                   {"id":"9","code":"A000884","name":"Leiomyosarcoma","cnt": 203},
                   {"id":"10","code":"A000944","name":"Liposarcoma","cnt": 22},
                   {"id":"11","code":"A001113","name":"Squamous cell carcinoma - Carcinoma","cnt": 55},
                   {"id":"12","code":"A002417","name":"Odontogenic myxoma","cnt": 34},
                   {"id":"13","code":"A003446","name":"Pleomorphic adenoma (benign mixed tumors)","cnt": 45},
                   {"id":"14","code":"A004533","name":"Gastrointestinal stroma tumors","cnt": 72},
                   {"id":"15","code":"A005460","name":"Hepatoblastoma","cnt": 34},
                   {"id":"16","code":"A006653","name":"Osteosarcoma","cnt": 546},
                   {"id":"17","code":"A007713","name":"Adenocarcinoma of gall bladder","cnt": 233},
               ]
           }
        }
    }
</script>

<style scoped>

</style>